import { type Ref } from 'vue'

import { type Product, type Image } from '@/types'

export const useProductJSONLD = (product: Ref<Product | undefined>) => {
  const productImages = computed<Image[]>(() => {
    if (!product.value || !product.value.images) return []
    return product.value.images.edges.map(edge => edge.node) as Image[]
  })

  const description = computed(() => {
    return product.value?.description || ''
  })

  const price = computed(() => {
    if (!product.value || !product.value.variants.edges[0].node) return 0
    return typeof product.value.variants.edges[0].node.price === 'string' ? product.value.variants.edges[0].node.price : product.value.variants.edges[0].node.price.amount 
  })

  useSchemaOrg([
    defineProduct({
      name: computed(() => product.value?.title || ''),
      description: description,
      image: defineImage({
        url: computed(() => productImages.value[0]?.url || ''),
        caption: computed(() => productImages.value[0]?.altText || description.value),
      }),
      hasMerchantReturnPolicy: {
        inStoreReturnsOffered: true,
        merchantReturnDays: 30,
      },
      sku: computed(() => product.value?.id || ''),
      offers: [
        { 
          price: price.value,
          priceCurrency: 'GBP',
        },
      ],
    })
  ]) 
}